import { render, staticRenderFns } from "./pavilion_list.vue?vue&type=template&id=96fd04c6&scoped=true&"
import script from "./pavilion_list.vue?vue&type=script&lang=js&"
export * from "./pavilion_list.vue?vue&type=script&lang=js&"
import style0 from "./pavilion_list.vue?vue&type=style&index=0&id=96fd04c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96fd04c6",
  null
  
)

export default component.exports